import classnames from "classnames";
import {FaMinus, FaPlus} from "react-icons/fa6";

import {Divider} from "@/components/divider/Divider.tsx";
import {IconButton} from "@/components/iconButton/IconButton.tsx";
import {thousandSeparatedInt} from "@/lib/format.tsx";

import styles from "./AddOnBox.module.scss";

interface AddOnBoxProps {
  amount?: number;
  price: number;
  onAdd?: () => void;
  onRemove?: () => void;
  canAdd: boolean;
  canRemove: boolean;
  loading?: boolean;
}

export const AddOnBox = ({amount, price, onRemove, onAdd, canAdd, canRemove, loading}: AddOnBoxProps) => {
  return (
    <div className={styles.box}>
      <div className={styles.title}>Add Additional Cloud Status Checks</div>
      <div className={classnames(styles.buttonBar)}>
        <IconButton variant="secondary" icon={FaMinus} onClick={onRemove} disabled={!canRemove || loading} />
        <span className={styles.amount}>{amount}</span>
        <IconButton variant="secondary" icon={FaPlus} onClick={onAdd} disabled={!canAdd || loading} />
      </div>
      <Divider className={styles.divider} />
      <div className={styles.price}>
        <span className={styles.priceTitle}>Additional monthly total:</span>
        <span className="fs-6 fw-medium d-flex align-items-center">
          $ <span className="pulseTextH2Bold fs-4 me-1">{thousandSeparatedInt(price)}</span>/ mo
        </span>
      </div>
    </div>
  );
};
